<template>
    <Table/>
</template>
<script>
import Table from "./MyTable.vue";
export default {
  components: {
    Table
  },
};
</script>
<style></style>
